import request from '@/utils/request'
// 获取地址列表
export const getRegion = () => {
  return request.get('/region')
}
